module.exports = __webpack_public_path__ + "media/images/flags/va-8e3ea81b38f1acbea43aacd7ee8c63ba.svg";